import { BlockStack, Button, Card, Icon, IconSource, InlineStack, Text } from "@shopify/polaris";
import { ReactNode } from "react";

import { CardSkeleton } from "./CardSkeleton";

interface CustomCardProps {
  buttonText?: null | string;
  children: ReactNode;
  disabled?: boolean;
  icon: IconSource;
  loading?: boolean;
  onAction?: (() => void) | null;
  title: string;
}

export const CustomCard = ({
  buttonText = null,
  children,
  disabled = false,
  icon,
  loading,
  onAction = null,
  title,
}: CustomCardProps) => {
  if (loading) {
    return <CardSkeleton />;
  }

  return (
    <Card>
      <BlockStack>
        <InlineStack align="space-between" blockAlign="center">
          <InlineStack gap="200">
            <Icon source={icon} tone="primary" />
            <Text as="h6" variant="headingMd">
              {title}
            </Text>
          </InlineStack>
          {buttonText && onAction && (
            <Button disabled={disabled} onClick={onAction} variant="primary">
              {buttonText}
            </Button>
          )}
        </InlineStack>
        {children}
      </BlockStack>
    </Card>
  );
};
